import { Box } from '@mui/material'
import cn from 'classnames'
import s from './ActionButton.modules.scss'

const ActionButton = props => {
  const { label, onClick, disabled } = props

  return (
    <Box className={cn(s.btn, { [s.disabled]: disabled })} onClick={onClick}>
      {label}
    </Box>
  )
}

export default ActionButton
